export const shippingCarriers = [
  { value: 'fedex', label: 'FedEx' },
  { value: 'ups', label: 'UPS' },
];

export const shippingCarrierValues = shippingCarriers.map(({ value }) => value);
